/**
 * Created by kaiyan2 on 08/02/2017.
 */

import React from 'react';
// import axios from 'axios';
import { generateInfoCard } from "Common/utility/infoCard";
import { fetchBlogs/*, getCreatorAvatar*/ } from "Common/utility/blog";

class CiscoBlog extends React.Component {
	constructor(props) {
		super(props);
		this.rootRef = React.createRef();
		this.state = {
			items: null
		};

		this.getBlogData = this.getBlogData.bind(this);
		this.renderItems = this.renderItems.bind(this);
		this.generateItems = this.generateItems.bind(this);
	}

	componentDidMount() {
		if (this.props.config) {
			this.getBlogData(this.props);
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.config != prevProps.config && this.props.config) {
			this.getBlogData(this.props);
		}
	}

	getBlogData(props) {
		const config = props.config;
		const catalog = config.querySelector('catalog') ? config.querySelector('catalog').innerHTML.replace(/\s/g, '') : '';

		fetchBlogs(catalog)
			.then(this.generateItems.bind(this))
			.catch(this.handleError.bind(this));
	}

	handleError() {
		this.setState({
			items: []
		});
	}
/*
	_updateAuthorAvatar() {
		let storage = window.localStorage || {};
		let storageKey = 'ciscoblog.avatars';
		let blogAvatars = JSON.parse(storage[storageKey] || "{}");
		let items = this.state.items;
		let promise = null;

		for (let i = 0; i < items.length; i++) {
			let item = items[i];
			let { src } = item.image;
			let { url: creatorUrl, creatorId } = item.author;
			let avatar = blogAvatars[creatorId];
			if (avatar) {
				item.image.src = avatar;
				this.setState({ items });
			} else if (creatorUrl) {
				let p = getCreatorAvatar(creatorId).then(avatar => {
					item.image.src = avatar;
					this.setState({ items });
					blogAvatars[creatorId] = avatar;
				}).catch(err => console.log(err));
				if (promise) {
					promise = promise.then(() => p);
				} else {
					promise = p;
				}
			}
		}

		if (promise) {
			promise.then(() => {
				if (window.localStorage) {
					window.localStorage.setItem(storageKey, JSON.stringify(blogAvatars));
				}
			});
		}
	}*/

	generateItems(data) {
		if (!data || Object.prototype.toString.call(data) != '[object Array]') {
			this.setState({
				items: []
			});
			return;
		}

		let items = [];
		const _data = data;
		const itemSize = _data.length > 4 ? 4 : _data.length;
		for (let i = 0; i < itemSize; i++) {
			let itemData = _data[i];
			let item = {
				title: itemData.title,
				image: {
					src: itemData.author.link,
					url: itemData.link,
					target: "_blank"
				},
				author: {
					name: itemData.author.name,
					// url: itemData.author.link,
					// target: "_blank"
				},
				time: (new Date(itemData.created)).toLocaleDateString(),
				link:itemData.link 
			};
			items.push(item);
		}
		this.rootRef.current && this.setState({
			items
		});
		// this._updateAuthorAvatar();
	}

	renderItems(item, index) {
		const elements = generateInfoCard(item, this.props.type);
		return (
			<div key={index} className="pubhub-discussion-list-item row aligin-items-center">
				{/* <div className="col-auto pubhub-discussion-list-item-img">
					<span data-track-name="discussion:item:image"
						data-track-value={item.title} >
						{elements.image}
					</span>

				</div> */}
				<div className="col pubhub-discussion-list-item-title ">
					<span data-track-name="discussion:item:title"
						data-track-value={item.title} >
						{elements.title}
					</span>

					<div className="pubhub-discussion-list-item-subtitle">{item.time} by <a
						className="pubhub-discussion-list-item-subtitle-link" href={item.author.url}
					target={item.author.target} rel={item.author.target === '_blank' ? 'noopener noreferrer' : undefined}>{item.author.name}</a></div>
				</div>
			</div>
		);
	}

	renderTitle(config) {
		const title = config.queryChild("title") ? config.queryChild("title").innerHTML.trim() : null;
		const href = config.queryChild("hyperlink") ? config.queryChild("hyperlink").innerHTML.trim() : null;

		return href ? (
			<a href={href} target="_blank" rel="noopener noreferrer">
				<h3 className="pubhub-discussion-title">
					{title}
				</h3>
			</a>
		) : (
			<h3 className="pubhub-discussion-title">
				{title}
			</h3>
		);
	}

	render() {
		const { config } = this.props;
		if (!config) {
			return <span className="pubhub-loading"></span>;
		}

		let content = <span className="pubhub-loading"></span>;
		if (this.state.items) {
			if (this.state.items.length) {
				content = this.state.items.map(this.renderItems);
			} else {
				let noContent = 'No Blogs';
				content = <p>{noContent}</p>
			}
		}

		const title = this.renderTitle(config);

		return (
			<div className="pubhub-discussion pubhub-widget" ref={this.rootRef}>
				{title}
				<div className="container">
					<div className="row pubhub-discussion-list">
						<div className="col-12">
							{content}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default CiscoBlog;
